import { render } from "./SpeedDisplay.vue?vue&type=template&id=2b0120cc"
import script from "./SpeedDisplay.vue?vue&type=script&lang=js"
export * from "./SpeedDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__